import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';

const Video = ({ content }) => (
  <Head>
    <meta name="og:video" content={content} key="og:video" />
  </Head>
);

Video.propTypes = {
  content: PropTypes.string,
};

Video.defaultProps = {
  content: 'https://coursalytics.com/',
};

export default Video;
